import notAllowedAccessIllustration from '@/assets/not-found-page.jpg';
import ErrorMessage from '@/components/ErrorMessage';
import PageLayout from '@/components/general/PageLayout';

const NotFoundPage = (): JSX.Element => {
  return (
    <PageLayout>
      <ErrorMessage
        data-testid="not-found-page"
        title="Oops... We didn't find the page you're looking for"
        illustration={notAllowedAccessIllustration}
        aboveTitle="Error 404"
        description={
          <div>
            <p>Use the menu above to navigate to a different page.</p>
          </div>
        }
      />
    </PageLayout>
  );
};

export default NotFoundPage;
